import { DismissInsightModal } from "../Common/Modals/DismissInsightModal";
import { INSIGHT_CATEGORY } from "../../Types/account";
import {
  TUTORIAL_DEMO_INSIGHTS,
  TUTORIAL_SCENARIO,
} from "../../Constants/tutorialScenario";
import "../../Css/Common/Modals/GlassModal.css";

type TutorialDemoDismissInsightModalProps = {
  onClose?: () => void;
};

/** Real DismissInsightModal shell for the App Guide (no-op submit). */
export function TutorialDemoDismissInsightModal({
  onClose,
}: TutorialDemoDismissInsightModalProps) {
  const handleClose = onClose ?? (() => {});

  return (
    <div className="tutorialDemoOverlay_backdrop" aria-hidden={false}>
      <div
        className="tutorialDemoOverlay_insightModalShell"
        data-tour="insight-dismiss-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <DismissInsightModal
          insightId={TUTORIAL_DEMO_INSIGHTS[0].id}
          insightType={INSIGHT_CATEGORY.ACCOUNT}
          accountId={TUTORIAL_SCENARIO.primaryAccount.uuid}
          clientId={null}
          onClose={handleClose}
          onDismiss={() => {}}
        />
      </div>
    </div>
  );
}
